import { KeyValue } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { createMask } from '@ngneat/input-mask';
import { ComplianceSettingForm } from 'src/app/classes/form-groups/compliance-setting-form';
import { ComplianceSettingLiabilityType } from 'src/app/interfaces/compliance-setting-liability-types';
import { UtilityService } from 'src/app/services/utility.service';

@Component({
  selector: 'app-compliance-umbrella-liability',
  templateUrl: './compliance-umbrella-liability.component.html',
  styleUrls: ['./compliance-umbrella-liability.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ComplianceUmbrellaLiabilityComponent {
  constructor(private UtilityService: UtilityService) {}

  @Input() complianceSettingForms?: ComplianceSettingForm[];
  @Input() amBestValueMap?: Map<string, string | number | null>;
  @Input() amBestFinancialValueMap?: Map<
    string,
    { value: string | null; hint: string }
  >;

  @Output() updateRequiredFields =
    new EventEmitter<ComplianceSettingLiabilityType>();

  checkBoxFields?: Map<string, { controlName: string; show: boolean }>;

  collapse: boolean = true;

  currencyMask = createMask({
    alias: 'numeric',
    groupSeparator: ',',
    placeholder: '',
    rightAlign: false
  });

  // The currency mask parser doesn't work. So, we'll handle it ourselves.
  applyCurrencyFormat(FormControl: FormControl, value: any) {
    FormControl.patchValue(
      value === null ? null : parseInt(value.replace(/[^\d]/g, ''), 10),
      { emitViewToModelChange: false }
    );
  }

  keyValuePairDefaultOrder(
    a: KeyValue<any, any>,
    b: KeyValue<any, any>
  ): number {
    return 0;
  }

  onUmbrellaLiabilityIsRequiredChange() {
    this.updateRequiredFields.emit('umbrellaLiability');
  }

  ngOnInit(): void {
    this.updateRequiredFields.emit('umbrellaLiability');

    this.checkBoxFields = new Map([
      ['Additional Insured', { controlName: 'umbIsNamed', show: true }],
      ['Waiver of Subrogation', { controlName: 'umbIsAgency', show: true }],
      [
        'Valid Description of Operations',
        { controlName: 'umbDescOps', show: true }
      ],
      [
        'Pass Full Policy Review',
        { controlName: 'umbrellaLiability_hasFullPolicyDoc', show: true }
      ],
      [
        'Has Required Forms',
        { controlName: 'umbrellaLiability_hasRequiredForms', show: true }
      ],
      [
        'Primary & Non-Contributory',
        { controlName: 'umbrellaLiability_primaryNonContributory', show: true }
      ],
      [
        'Occurrence Based',
        { controlName: 'umbrellaLiability_occurrenceBased', show: true }
      ],
      [
        'COI Name/Legal Name Mismatch',
        { controlName: 'umbrellaLiability_legalNameMismatch', show: true }
      ]
    ]);
  }
}
